import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "dark",
  user: null,
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
    },
    setUserPFP: (state, action) => {
      state.user.profilePic = action.payload;
    },
  },
});

export const { setMode, setUser, clearUser, setUserPFP } = globalSlice.actions;

export default globalSlice.reducer;